/**
 * set of functions to enforce group data structure
 */
import Config from 'config/config';
import stripTags from 'src/utils/stripTags';
import fieldsToStructure from './fieldsToStructure';

const preservedFields = [
  'memberCount',
  'postCount',
  'visitCount',
  'contactNumber',
  'country',
  'gaTrackingCode',
];
const getId = group => group.id || group.groupId;

export default {
  ...fieldsToStructure(preservedFields),
  id: getId,

  name(group) {
    return stripTags(group.name || group.formattedName) || undefined;
  },

  avatar(group) {
    let url = group.imageUrl ||
      (group.logoImageHash && `${Config.cdn.communityLogos}${group.logoImageHash}_140x140.jpg`);

    if (url && url.substring(0, 6) !== 'https:') {
      url = 'https:' + url;
    }

    return url || undefined;
  },

  banner(group) {
    let url = group.bannerUrl;

    if (url && url.substring(0, 6) !== 'https:') {
      url = 'https:' + url;
    }

    return url || undefined;
  },

  groupCode(group) {
    return group.groupCode || group.subDomain;
  },

  formattedDesc(group) {
    return stripTags(group.description || group.formattedDescription) || undefined;
  },

  isFollowing(group) {
    return group.isFollowedByCurrentUser || group.isFollowing;
  },

  hasWebsite(group) {
    return !!group.formattedWebsite;
  },

  website(group) {
    return stripTags(group.formattedWebsite) || undefined;
  },

  hasSupportLink(group) {
    return !!group.formattedSupportLink && !!group.formattedSupportButtonText;
  },

  supportLink(group) {
    return stripTags(group.formattedSupportLink) || undefined;
  },

  supportAction(group) {
    return stripTags(group.formattedSupportButtonText) || undefined;
  },
};



// WEBPACK FOOTER //
// ./src/utils/dataStructure/structures/groupStructure.js